import { Box, Button, Paper, Stack, Theme, Typography } from "@mui/material";
import { ReactNode } from "react";
import { ActionMenuItem } from "../../action-menu/ActionMenuItem";
import { DashboardChartLoading } from "../dashboard-chart-loading/DashboardChartLoading";
import { DashboardGraphLoading } from "../dashboard-graph-loading/DashboardGraphLoading";
import { SxProps } from "@mui/system";
import { DashboardTableLoading } from "../dashboard-table-loading/DashboardTableLoading";
import { ContextActionMenu } from "../../contextual-app-bar/ContextActionMenu";

export enum DashboardContainerType {
    Chart = 0,
    Graph = 1,
    Table = 2
}

export type DashboardContainerProps = {
    dashboardContainerType: DashboardContainerType,
    title: string;
    loading: boolean;
    actions?: ActionMenuItem[];
    useContextActionMenu?: boolean;
    onExecuteAction?: (menuItem: ActionMenuItem) => void;
    children?: ReactNode;
    sx?: SxProps<Theme>;
};

export function DashboardContainer({
    dashboardContainerType,
    title,
    loading,
    actions,
    useContextActionMenu,
    onExecuteAction,
    sx,
    children
}: DashboardContainerProps) {

    return (
        <Paper sx={{
            display: "flex",
            flexDirection: "column",
            flex: '1 1 auto',
            padding: 1,
            overflow: 'hidden'
        }}
            elevation={3}
            // onClick={() => console.log("**** Clicked card")}
        >
            <Stack
                direction='row'
                sx={{
                    justifyContent: 'space-between',
                    alignItems: "center",
                    height: theme => useContextActionMenu ? theme.spacing(6) : "auto"
                }}>
                <Typography
                    variant="subtitle1"
                    component="div"
                    sx={{
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        display: 'flex',
                        textTransform: 'uppercase',
                        flex: '1 1 auto'
                    }}>
                    {title}
                </Typography>
                {useContextActionMenu &&
                    <ContextActionMenu
                        actions={actions}
                        onExecuteAction={onExecuteAction}
                        hideAddToFavoritesAction={true}
                        hideOptionsAction={true}
                    />
                }

                {!useContextActionMenu &&
                    <>
                        {actions?.map((o, index) =>
                            <Button key={index}
                                size="small"
                                sx={{
                                    color: o.color ?? "secondary.main",
                                    whiteSpace: 'nowrap'
                                }}
                                onClick={() => onExecuteAction && onExecuteAction(o)}
                            >
                                {o.label}
                            </Button>
                        )}
                    </>
                }
            </Stack>
            {
                loading ?

                    dashboardContainerType === DashboardContainerType.Chart
                        ? <DashboardChartLoading />
                        : dashboardContainerType === DashboardContainerType.Graph
                            ? <DashboardGraphLoading />
                            : <DashboardTableLoading />
                    :

                    <Box sx={{
                        position: 'relative',
                        display: "flex",
                        flexDirection: "column",
                        flex: '1 1 auto',
                        overflow: "hidden",
                        overflowY: 'auto',
                        ...sx
                    }}>
                        {children}
                    </Box>
            }
        </Paper>
    );
}
